import { graphql } from "gql/apollo";

export const ListIntegrations = graphql(/* GraphQL */ `
	query ListGenetecIntegrations {
		integrations: listGenetecIntegrations(params: {}) {
			gid
			name
			server
			username
			mapID
			disabled
		}
		account: getAccount {
			settings {
				limit: max_genetec_integrations
			}
		}
	}
`);
